(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $9ecc61fdda8d7e00$exports = {};
$9ecc61fdda8d7e00$exports = jQuery;


const $a27ec4aed69ec0cd$var$proNotice = {
    show: (autoHide)=>{
        const notice = document.querySelector(".udb-pro-login-customizer-notice");
        if (!notice) return;
        notice.classList.add("is-shown");
        if (autoHide) setTimeout($a27ec4aed69ec0cd$var$proNotice.hide, 3000);
    },
    hide: ()=>{
        var notice = document.querySelector(".udb-pro-login-customizer-notice");
        if (!notice) return;
        notice.classList.remove("is-shown");
    }
};
var $a27ec4aed69ec0cd$export$2e2bcd8739ae039 = $a27ec4aed69ec0cd$var$proNotice;


const $e6d08691f65044c6$var$listenProNoticeEvent = ()=>{
    wp.customize.preview.bind("pro_notice", function(action) {
        if (action === "show") (0, $a27ec4aed69ec0cd$export$2e2bcd8739ae039).show();
        else (0, $a27ec4aed69ec0cd$export$2e2bcd8739ae039).hide();
    });
};
var $e6d08691f65044c6$export$2e2bcd8739ae039 = $e6d08691f65044c6$var$listenProNoticeEvent;


const $a73a302a0251d813$var$listenPreviewSwitchEvent = ()=>{
    wp.customize.preview.bind("udb-login-customizer-goto-login-page", function(data) {
        // When the section is expanded, open the login customizer page.
        if (data.expanded) wp.customize.preview.send("url", udbLoginCustomizer.loginPageUrl);
    });
    wp.customize.preview.bind("udb-login-customizer-goto-home-page", function(data) {
        wp.customize.preview.send("url", data.url);
    });
};
var $a73a302a0251d813$export$2e2bcd8739ae039 = $a73a302a0251d813$var$listenPreviewSwitchEvent;


const $f670a0041692df6f$var$listenLogoHeightFieldChange = ()=>{
    wp.customize("udb_login[logo_height]", function(setting) {
        setting.bind(function(val) {
            const el = document.querySelector('[data-listen-value="udb_login[logo_height]"]');
            if (!el) return;
            el.innerHTML = ".login h1 a, .login .wp-login-logo a {background-size: auto " + val + ";}";
        });
    });
};
var $f670a0041692df6f$export$2e2bcd8739ae039 = $f670a0041692df6f$var$listenLogoHeightFieldChange;


const $9e2e3fc222777c2c$var$listenLogoImageFieldChange = (opts)=>{
    const logoLink = opts.logoLink;
    wp.customize("udb_login[logo_image]", function(setting) {
        setting.bind(function(val) {
            if (val) logoLink.style.backgroundImage = "url(" + val + ")";
            else logoLink.style.backgroundImage = "url(" + udbLoginCustomizer.wpLogoUrl + ")";
        });
    });
};
var $9e2e3fc222777c2c$export$2e2bcd8739ae039 = $9e2e3fc222777c2c$var$listenLogoImageFieldChange;


const $7ea30e7b33c84a73$var$listenLogoTitleFieldChange = (opts)=>{
    const logoLink = opts.logoLink;
    wp.customize("udb_login[logo_title]", function(setting) {
        setting.bind(function(val) {
            logoLink.innerHTML = val;
        });
    });
};
var $7ea30e7b33c84a73$export$2e2bcd8739ae039 = $7ea30e7b33c84a73$var$listenLogoTitleFieldChange;


const $36203d7ae183f0a0$var$listenLogoUrlFieldChange = (opts)=>{
    const logoLink = opts.logoLink;
    wp.customize("udb_login[logo_url]", function(setting) {
        setting.bind(function(val) {
            val = val.replace("{home_url}", udbLoginCustomizer.homeUrl);
            logoLink.href = val;
        });
    });
};
var $36203d7ae183f0a0$export$2e2bcd8739ae039 = $36203d7ae183f0a0$var$listenLogoUrlFieldChange;


const $fc3864525fc0e41d$var$listenLogoFieldsChange = ()=>{
    const logoLink = document.querySelector(".udb-login--logo-link");
    (0, $9e2e3fc222777c2c$export$2e2bcd8739ae039)({
        logoLink: logoLink
    });
    (0, $36203d7ae183f0a0$export$2e2bcd8739ae039)({
        logoLink: logoLink
    });
    (0, $7ea30e7b33c84a73$export$2e2bcd8739ae039)({
        logoLink: logoLink
    });
    (0, $f670a0041692df6f$export$2e2bcd8739ae039)();
};
var $fc3864525fc0e41d$export$2e2bcd8739ae039 = $fc3864525fc0e41d$var$listenLogoFieldsChange;


const $6bf77abec7ca7d4b$var$writeStyle = (opts)=>{
    let el = opts.styleEl;
    const selector = opts.cssSelector;
    const rules = opts.cssRules;
    if (typeof el === "string") el = document.querySelector(el);
    if (!el) return;
    el.innerHTML = selector + " {" + rules + "}";
};
var $6bf77abec7ca7d4b$export$2e2bcd8739ae039 = $6bf77abec7ca7d4b$var$writeStyle;


const $aa658f2331e8edc1$var$writeBgPositionStyle = (opts)=>{
    let el = opts.styleEl;
    const selector = opts.cssSelector;
    const keyPrefix = opts.keyPrefix ? opts.keyPrefix : "";
    const bgPosition = opts.bgPosition;
    let bgCustomPosition = opts.bgCustomPosition ? opts.bgCustomPosition : "";
    if (typeof el === "string") el = document.querySelector(el);
    if (!el) return;
    bgCustomPosition = bgCustomPosition ? bgCustomPosition : wp.customize("udb_login[" + keyPrefix + "bg_custom_position]").get();
    (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
        styleEl: el,
        cssSelector: selector,
        cssRules: "background-position: " + (bgPosition === "custom" ? bgCustomPosition : bgPosition) + ";"
    });
};
var $aa658f2331e8edc1$export$2e2bcd8739ae039 = $aa658f2331e8edc1$var$writeBgPositionStyle;



const $7d2749d9e5172f63$var$getFormPosition = ()=>{
    let formPosition = wp.customize("udb_login[form_position]").get();
    formPosition = !udbLoginCustomizer.isProActive ? "default" : formPosition;
    return formPosition;
};
var $7d2749d9e5172f63$export$2e2bcd8739ae039 = $7d2749d9e5172f63$var$getFormPosition;


const $da789af4f043eac4$var$toggleBgOverlay = (show)=>{
    const target = document.querySelector(".udb-bg-overlay");
    if (!target) return;
    if (show) target.style.display = "block";
    else target.style.display = "none";
};
var $da789af4f043eac4$export$2e2bcd8739ae039 = $da789af4f043eac4$var$toggleBgOverlay;


const $4a32611bd28aed5d$var$listenBgImageFieldChange = (opts)=>{
    const keyPrefix = opts.keyPrefix;
    wp.customize("udb_login[" + keyPrefix + "bg_image]", function(setting) {
        let cssSelector = opts.cssSelector;
        const bgImageStyleTag = document.querySelector('[data-listen-value="udb_login[' + keyPrefix + 'bg_image]"]');
        setting.bind(function(val) {
            const formPosition = (0, $7d2749d9e5172f63$export$2e2bcd8739ae039)();
            if (keyPrefix === "form_" && formPosition !== "default") cssSelector = "#login";
            if (val) {
                (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
                    styleEl: bgImageStyleTag,
                    cssSelector: cssSelector,
                    cssRules: "background-image: url(" + val + ");"
                });
                // The overlay feature is only for bg_image, not for for form_bg_image.
                if (!keyPrefix) {
                    const enableBgOverlay = wp.customize("udb_login[enable_bg_overlay_color]").get();
                    if (enableBgOverlay) (0, $da789af4f043eac4$export$2e2bcd8739ae039)(true);
                    else (0, $da789af4f043eac4$export$2e2bcd8739ae039)(false);
                }
            } else {
                (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
                    styleEl: bgImageStyleTag,
                    cssSelector: cssSelector,
                    cssRules: "background-image: none;"
                });
                // The overlay feature is only for bg_image, not for for form_bg_image.
                if (!keyPrefix) (0, $da789af4f043eac4$export$2e2bcd8739ae039)(false);
            }
            const bgRepeat = wp.customize("udb_login[" + keyPrefix + "bg_repeat]").get();
            (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[' + keyPrefix + 'bg_repeat]"]',
                cssSelector: cssSelector,
                cssRules: "background-repeat: " + bgRepeat + ";"
            });
            const bgPosition = wp.customize("udb_login[" + keyPrefix + "bg_position]").get();
            (0, $aa658f2331e8edc1$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[' + keyPrefix + 'bg_position]"]',
                keyPrefix: keyPrefix,
                cssSelector: cssSelector,
                bgPosition: bgPosition
            });
            const bgSize = wp.customize("udb_login[" + keyPrefix + "bg_size]").get();
            (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[' + keyPrefix + 'bg_size]"]',
                cssSelector: cssSelector,
                cssRules: "background-size: " + bgSize + ";"
            });
        }); // End of setting.bind();
    }); // End of wp.customize();
};
var $4a32611bd28aed5d$export$2e2bcd8739ae039 = $4a32611bd28aed5d$var$listenBgImageFieldChange;




const $62b401f9fb04b0cc$var$listenBgPositionFieldChange = (opts)=>{
    const keyPrefix = opts.keyPrefix;
    wp.customize("udb_login[" + keyPrefix + "bg_position]", function(setting) {
        let cssSelector = opts.cssSelector;
        setting.bind(function(val) {
            const formPosition = (0, $7d2749d9e5172f63$export$2e2bcd8739ae039)();
            if (keyPrefix === "form_" && formPosition !== "default") cssSelector = "#login";
            (0, $aa658f2331e8edc1$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[' + keyPrefix + 'bg_position]"]',
                keyPrefix: keyPrefix,
                cssSelector: cssSelector,
                bgPosition: val
            });
        });
    });
};
var $62b401f9fb04b0cc$export$2e2bcd8739ae039 = $62b401f9fb04b0cc$var$listenBgPositionFieldChange;




const $182c35f822c2319c$var$listenBgCustomPositionFieldChange = (opts)=>{
    const keyPrefix = opts.keyPrefix;
    wp.customize("udb_login[" + keyPrefix + "bg_custom_position]", function(setting) {
        let cssSelector = opts.cssSelector;
        setting.bind(function(val) {
            const formPosition = (0, $7d2749d9e5172f63$export$2e2bcd8739ae039)();
            if (keyPrefix === "form_" && formPosition !== "default") cssSelector = "#login";
            const bgPosition = wp.customize("udb_login[" + keyPrefix + "bg_position]").get();
            (0, $aa658f2331e8edc1$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[' + keyPrefix + 'bg_position]"]',
                keyPrefix: keyPrefix,
                cssSelector: cssSelector,
                bgPosition: bgPosition,
                bgCustomPosition: val
            });
        });
    });
};
var $182c35f822c2319c$export$2e2bcd8739ae039 = $182c35f822c2319c$var$listenBgCustomPositionFieldChange;




const $fcd892fe27073f97$var$listenBgRepeatFieldChange = (opts)=>{
    const keyPrefix = opts.keyPrefix;
    wp.customize("udb_login[" + keyPrefix + "bg_repeat]", function(setting) {
        let cssSelector = opts.cssSelector;
        const bgRepeatStyleTag = document.querySelector('[data-listen-value="udb_login[' + keyPrefix + 'bg_repeat]"]');
        setting.bind(function(val) {
            const formPosition = (0, $7d2749d9e5172f63$export$2e2bcd8739ae039)();
            if (keyPrefix === "form_" && formPosition !== "default") cssSelector = "#login";
            (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
                styleEl: bgRepeatStyleTag,
                cssSelector: cssSelector,
                cssRules: "background-repeat: " + val + ";"
            });
        });
    });
};
var $fcd892fe27073f97$export$2e2bcd8739ae039 = $fcd892fe27073f97$var$listenBgRepeatFieldChange;



const $eeb86e7c51b5e525$var$writeBgSizeStyle = (opts)=>{
    let el = opts.styleEl;
    const selector = opts.cssSelector;
    const keyPrefix = opts.keyPrefix ? opts.keyPrefix : "";
    const bgSize = opts.bgSize;
    let bgCustomSize = opts.bgCustomSize ? opts.bgCustomSize : "";
    if (typeof el === "string") el = document.querySelector(el);
    if (!el) return;
    bgCustomSize = bgCustomSize ? bgCustomSize : wp.customize("udb_login[" + keyPrefix + "bg_custom_size]").get();
    (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
        styleEl: el,
        cssSelector: selector,
        cssRules: "background-size: " + (bgSize === "custom" ? bgCustomSize : bgSize) + ";"
    });
};
var $eeb86e7c51b5e525$export$2e2bcd8739ae039 = $eeb86e7c51b5e525$var$writeBgSizeStyle;



const $af66c3999283ccf3$var$listenBgSizeFieldChange = (opts)=>{
    const keyPrefix = opts.keyPrefix;
    wp.customize("udb_login[" + keyPrefix + "bg_size]", function(setting) {
        let cssSelector = opts.cssSelector;
        setting.bind(function(val) {
            const formPosition = (0, $7d2749d9e5172f63$export$2e2bcd8739ae039)();
            if (keyPrefix === "form_" && formPosition !== "default") cssSelector = "#login";
            (0, $eeb86e7c51b5e525$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[' + keyPrefix + 'bg_size]"]',
                keyPrefix: keyPrefix,
                cssSelector: cssSelector,
                bgSize: val
            });
        });
    });
};
var $af66c3999283ccf3$export$2e2bcd8739ae039 = $af66c3999283ccf3$var$listenBgSizeFieldChange;




const $4f2fa2c70f2fdbf8$var$listenBgCustomSizeFieldChange = (opts)=>{
    const keyPrefix = opts.keyPrefix;
    wp.customize("udb_login[" + keyPrefix + "bg_custom_size]", function(setting) {
        let cssSelector = opts.cssSelector;
        setting.bind(function(val) {
            const formPosition = (0, $7d2749d9e5172f63$export$2e2bcd8739ae039)();
            if (keyPrefix === "form_" && formPosition !== "default") cssSelector = "#login";
            const bgSize = wp.customize("udb_login[" + keyPrefix + "bg_size]").get();
            (0, $eeb86e7c51b5e525$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[' + keyPrefix + 'bg_size]"]',
                keyPrefix: keyPrefix,
                cssSelector: cssSelector,
                bgSize: bgSize,
                bgCustomSize: val
            });
        });
    });
};
var $4f2fa2c70f2fdbf8$export$2e2bcd8739ae039 = $4f2fa2c70f2fdbf8$var$listenBgCustomSizeFieldChange;


const $77195c7aafa00920$var$listenBgOverlayColorFieldChange = ()=>{
    wp.customize("udb_login[bg_overlay_color]", function(setting) {
        const bgOverlayColorStyleTag = document.querySelector('[data-listen-value="udb_login[bg_overlay_color]"]');
        setting.bind(function(val) {
            let rule;
            if (val) {
                rule = "background-color: " + val + ";";
                bgOverlayColorStyleTag.innerHTML = ".udb-bg-overlay {" + rule + "}";
            } else {
                rule = "background-color: transparent;";
                bgOverlayColorStyleTag.innerHTML = ".udb-bg-overlay {" + rule + "}";
            }
        });
    });
};
var $77195c7aafa00920$export$2e2bcd8739ae039 = $77195c7aafa00920$var$listenBgOverlayColorFieldChange;



const $caa556a19e80ddd5$var$listenEnableBgOverlayColorFieldChange = ()=>{
    wp.customize("udb_login[enable_bg_overlay_color]", function(setting) {
        setting.bind(function(val) {
            (0, $da789af4f043eac4$export$2e2bcd8739ae039)(val);
        });
    });
};
var $caa556a19e80ddd5$export$2e2bcd8739ae039 = $caa556a19e80ddd5$var$listenEnableBgOverlayColorFieldChange;


const $69d53b767702c009$var$listenBgFieldsChange = (opts)=>{
    const keyPrefix = opts.keyPrefix;
    (0, $4a32611bd28aed5d$export$2e2bcd8739ae039)({
        keyPrefix: keyPrefix,
        cssSelector: opts.cssSelector
    });
    (0, $fcd892fe27073f97$export$2e2bcd8739ae039)({
        keyPrefix: keyPrefix,
        cssSelector: opts.cssSelector
    });
    (0, $62b401f9fb04b0cc$export$2e2bcd8739ae039)({
        keyPrefix: keyPrefix,
        cssSelector: opts.cssSelector
    });
    (0, $182c35f822c2319c$export$2e2bcd8739ae039)({
        keyPrefix: keyPrefix,
        cssSelector: opts.cssSelector
    });
    (0, $af66c3999283ccf3$export$2e2bcd8739ae039)({
        keyPrefix: keyPrefix,
        cssSelector: opts.cssSelector
    });
    (0, $4f2fa2c70f2fdbf8$export$2e2bcd8739ae039)({
        keyPrefix: keyPrefix,
        cssSelector: opts.cssSelector
    });
    // The overlay feature is only for bg_image, not for for form_bg_image.
    if (!keyPrefix) {
        (0, $caa556a19e80ddd5$export$2e2bcd8739ae039)();
        (0, $77195c7aafa00920$export$2e2bcd8739ae039)();
    }
};
var $69d53b767702c009$export$2e2bcd8739ae039 = $69d53b767702c009$var$listenBgFieldsChange;


// Import fields change listeners.

const $70fdd0b7fe43dfbd$var$writeStyles = (opts)=>{
    let el = opts.styleEl;
    const styles = opts.styles;
    if (!Array.isArray(styles)) return;
    if (typeof el === "string") el = document.querySelector(el);
    if (!el) return;
    let output = "";
    styles.forEach(function(style) {
        output += style.cssSelector + " {" + style.cssRules + "}";
    });
    el.innerHTML = output;
};
var $70fdd0b7fe43dfbd$export$2e2bcd8739ae039 = $70fdd0b7fe43dfbd$var$writeStyles;




const $4f54732ff3b04826$var$listenFormPositionFieldChange = ()=>{
    wp.customize("udb_login[form_position]", function(setting) {
        const formPositionStyleTag = document.querySelector('[data-listen-value="udb_login[form_position]"]');
        const formBgColorStyleTag = document.querySelector('[data-listen-value="udb_login[form_bg_color]"]');
        const formBgImageStyleTag = document.querySelector('[data-listen-value="udb_login[form_bg_image]"]');
        const formBgRepeatStyleTag = document.querySelector('[data-listen-value="udb_login[form_bg_repeat]"]');
        const formBgPositionStyleTag = document.querySelector('[data-listen-value="udb_login[form_bg_position]"]');
        const formBgSizeStyleTag = document.querySelector('[data-listen-value="udb_login[form_bg_size]"]');
        const formWidthStyleTag = document.querySelector('[data-listen-value="udb_login[form_width]"]');
        const formHorizontalPaddingStyleTag = document.querySelector('[data-listen-value="udb_login[form_horizontal_padding]"]');
        const formBorderWidthStyleTag = document.querySelector('[data-listen-value="udb_login[form_border_width]"]');
        const formBorderStyleStyleTag = document.querySelector('[data-listen-value="udb_login[form_border_style]"]');
        const formBorderColorStyleTag = document.querySelector('[data-listen-value="udb_login[form_border_color]"]');
        setting.bind(function(val) {
            const formBgColor = wp.customize("udb_login[form_bg_color]").get();
            const formBgImage = wp.customize("udb_login[form_bg_image]").get();
            const formBgRepeat = wp.customize("udb_login[form_bg_repeat]").get();
            const formBgPosition = wp.customize("udb_login[form_bg_position]").get();
            const formBgSize = wp.customize("udb_login[form_bg_size]").get();
            let formWidth = wp.customize("udb_login[form_width]").get();
            let formHorizontalPadding = wp.customize("udb_login[form_horizontal_padding]").get();
            formWidth = formWidth ? formWidth : "320px";
            formHorizontalPadding = formHorizontalPadding ? formHorizontalPadding : "24px";
            // The non "default" value is handled in the pro version.
            if (val === "default") {
                if (formBgColor) (0, $70fdd0b7fe43dfbd$export$2e2bcd8739ae039)({
                    styleEl: formBgColorStyleTag,
                    styles: [
                        {
                            cssSelector: "#login",
                            cssRules: "background-color: transparent;"
                        },
                        {
                            cssSelector: ".login form, #loginform",
                            cssRules: "background-color: " + formBgColor + ";"
                        }
                    ]
                });
                if (formBgImage) (0, $70fdd0b7fe43dfbd$export$2e2bcd8739ae039)({
                    styleEl: formBgImageStyleTag,
                    styles: [
                        {
                            cssSelector: "#login",
                            cssRules: "background-image: none;"
                        },
                        {
                            cssSelector: ".login form, #loginform",
                            cssRules: "background-image: url(" + formBgImage + ");"
                        }
                    ]
                });
                if (formBgRepeat) (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
                    styleEl: formBgRepeatStyleTag,
                    cssSelector: ".login form, #loginform",
                    cssRules: "background-repeat: " + formBgRepeat + ";"
                });
                if (formBgPosition) (0, $aa658f2331e8edc1$export$2e2bcd8739ae039)({
                    styleEl: formBgPositionStyleTag,
                    keyPrefix: "form_",
                    cssSelector: ".login form, #loginform",
                    bgPosition: formBgPosition
                });
                if (formBgSize) (0, $eeb86e7c51b5e525$export$2e2bcd8739ae039)({
                    styleEl: formBgSizeStyleTag,
                    keyPrefix: "form_",
                    cssSelector: ".login form, #loginform",
                    bgSize: formBgSize
                });
                formWidthStyleTag.innerHTML = formWidthStyleTag.innerHTML.replace("#loginform {max-width:", "#login {width:");
                formPositionStyleTag.innerHTML = "#login {margin-left: auto; margin-right: auto; width: " + formWidth + "; min-height: 0; background-color: transparent;} #loginform {min-width: 0; max-width: none;}";
                formHorizontalPaddingStyleTag.innerHTML = "#loginform {padding-left: " + formHorizontalPadding + "; padding-right: " + formHorizontalPadding + ";}";
                let formBorderWidth = wp.customize("udb_login[form_border_width]").get();
                formBorderWidth = formBorderWidth ? formBorderWidth : "2px";
                formBorderWidthStyleTag.innerHTML = "#loginform {border-width: " + formBorderWidth + ";}";
                let formBorderStyle = wp.customize("udb_login[form_border_style]").get();
                formBorderStyle = formBorderStyle ? formBorderStyle : "solid";
                formBorderStyleStyleTag.innerHTML = "#loginform {border-style: " + formBorderStyle + ";}";
                let formBorderColor = wp.customize("udb_login[form_border_color]").get();
                formBorderColor = formBorderColor ? formBorderColor : "#dddddd";
                formBorderColorStyleTag.innerHTML = "#loginform {border-color: " + formBorderColor + ";}";
            }
        });
    });
};
var $4f54732ff3b04826$export$2e2bcd8739ae039 = $4f54732ff3b04826$var$listenFormPositionFieldChange;



const $adb9332d1a2f0a7d$var$listenFormBgColorFieldChange = ()=>{
    wp.customize("udb_login[form_bg_color]", function(setting) {
        const formBgColorStyleTag = document.querySelector('[data-listen-value="udb_login[form_bg_color]"]');
        setting.bind(function(val) {
            let formPosition = wp.customize("udb_login[form_position]").get();
            formPosition = !udbLoginCustomizer.isProActive ? "default" : formPosition;
            val = val ? val : "#ffffff";
            formPosition = formPosition ? formPosition : "default";
            // The non "default" value is handled in the pro version.
            if (formPosition === "default") (0, $70fdd0b7fe43dfbd$export$2e2bcd8739ae039)({
                styleEl: formBgColorStyleTag,
                styles: [
                    {
                        cssSelector: "#login",
                        cssRules: "background-color: transparent;"
                    },
                    {
                        cssSelector: ".login form, #loginform",
                        cssRules: "background-color: " + val + ";"
                    }
                ]
            });
        });
    });
};
var $adb9332d1a2f0a7d$export$2e2bcd8739ae039 = $adb9332d1a2f0a7d$var$listenFormBgColorFieldChange;


const $d1f094e7e877f0f2$var$listenFormWidthFieldChange = ()=>{
    wp.customize("udb_login[form_width]", function(setting) {
        setting.bind(function(val) {
            var formPosition = wp.customize("udb_login[form_position]").get();
            formPosition = !udbLoginCustomizer.isProActive ? "default" : formPosition;
            var content = "";
            formPosition = formPosition ? formPosition : "default";
            if (formPosition === "default") content = "#login {width: " + val + ";}";
            else content = "#loginform {max-width: " + val + ";}";
            document.querySelector('[data-listen-value="udb_login[form_width]"]').innerHTML = content;
        });
    });
};
var $d1f094e7e877f0f2$export$2e2bcd8739ae039 = $d1f094e7e877f0f2$var$listenFormWidthFieldChange;


const $9acbbdb133c86a5a$var$listenFormTopPaddingFieldChange = ()=>{
    wp.customize("udb_login[form_top_padding]", function(setting) {
        setting.bind(function(val) {
            var content = "#loginform {padding-top: " + val + ";}";
            document.querySelector('[data-listen-value="udb_login[form_top_padding]"]').innerHTML = content;
        });
    });
};
var $9acbbdb133c86a5a$export$2e2bcd8739ae039 = $9acbbdb133c86a5a$var$listenFormTopPaddingFieldChange;


const $798a250210e66623$var$listenFormBottomPaddingFieldChange = ()=>{
    wp.customize("udb_login[form_bottom_padding]", function(setting) {
        setting.bind(function(val) {
            var content = "#loginform {padding-bottom: " + val + ";}";
            document.querySelector('[data-listen-value="udb_login[form_bottom_padding]"]').innerHTML = content;
        });
    });
};
var $798a250210e66623$export$2e2bcd8739ae039 = $798a250210e66623$var$listenFormBottomPaddingFieldChange;


const $855fcbbd98ade068$var$listenFormHorizontalPaddingFieldChange = ()=>{
    wp.customize("udb_login[form_horizontal_padding]", function(setting) {
        setting.bind(function(val) {
            var content = val ? "#loginform {padding-left: " + val + "; padding-right: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[form_horizontal_padding]"]').innerHTML = content;
        });
    });
};
var $855fcbbd98ade068$export$2e2bcd8739ae039 = $855fcbbd98ade068$var$listenFormHorizontalPaddingFieldChange;


const $04a84d6571bea074$var$listenFormBorderWidthFieldChange = ()=>{
    wp.customize("udb_login[form_border_width]", function(setting) {
        setting.bind(function(val) {
            var content = val ? "#loginform {border-width: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[form_border_width]"]').innerHTML = content;
        });
    });
};
var $04a84d6571bea074$export$2e2bcd8739ae039 = $04a84d6571bea074$var$listenFormBorderWidthFieldChange;


const $03136e43d792eff5$var$listenFormBorderStyleFieldChange = ()=>{
    wp.customize("udb_login[form_border_style]", function(setting) {
        setting.bind(function(val) {
            var content = val ? "#loginform {border-style: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[form_border_style]"]').innerHTML = content;
        });
    });
};
var $03136e43d792eff5$export$2e2bcd8739ae039 = $03136e43d792eff5$var$listenFormBorderStyleFieldChange;


const $933c10a2d63d6c1a$var$listenFormBorderColorFieldChange = ()=>{
    wp.customize("udb_login[form_border_color]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "#dddddd";
            document.querySelector('[data-listen-value="udb_login[form_border_color]"]').innerHTML = "#loginform {border-color: " + val + ";}";
        });
    });
};
var $933c10a2d63d6c1a$export$2e2bcd8739ae039 = $933c10a2d63d6c1a$var$listenFormBorderColorFieldChange;


const $3469419d17429865$var$listenFormBorderRadiusFieldChange = ()=>{
    wp.customize("udb_login[form_border_radius]", function(setting) {
        setting.bind(function(val) {
            var content = val ? "#loginform {border-radius: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[form_border_radius]"]').innerHTML = content;
        });
    });
};
var $3469419d17429865$export$2e2bcd8739ae039 = $3469419d17429865$var$listenFormBorderRadiusFieldChange;


const $e6d70ed298135569$var$buildBoxShadowCssRule = (blur, color)=>{
    let rule = "box-shadow: none;";
    if (!blur || !color) return rule;
    rule = "box-shadow: 0 0 " + blur + " 0 " + color + ";";
    return rule;
};
var $e6d70ed298135569$export$2e2bcd8739ae039 = $e6d70ed298135569$var$buildBoxShadowCssRule;


const $ec63a27f6e3e788d$var$listenEnableFormShadowFieldChange = ()=>{
    wp.customize("udb_login[enable_form_shadow]", function(setting) {
        setting.bind(function(val) {
            let shadowBlur;
            let shadowColor;
            let content;
            if (val) {
                shadowBlur = wp.customize("udb_login[form_shadow_blur]").get();
                shadowColor = wp.customize("udb_login[form_shadow_color]").get();
                content = (0, $e6d70ed298135569$export$2e2bcd8739ae039)(shadowBlur, shadowColor);
            } else content = "box-shadow: none;";
            content = "#loginform {" + content + "}";
            document.querySelector('[data-listen-value="udb_login[form_shadow]"]').innerHTML = content;
        });
    });
};
var $ec63a27f6e3e788d$export$2e2bcd8739ae039 = $ec63a27f6e3e788d$var$listenEnableFormShadowFieldChange;



const $d800ed81bd670610$var$listenFormShadowBlurFieldChange = ()=>{
    wp.customize("udb_login[form_shadow_blur]", function(setting) {
        setting.bind(function(val) {
            const shadowColor = wp.customize("udb_login[form_shadow_color]").get();
            let content = (0, $e6d70ed298135569$export$2e2bcd8739ae039)(val, shadowColor);
            content = "#loginform {" + content + "}";
            document.querySelector('[data-listen-value="udb_login[form_shadow]"]').innerHTML = content;
        });
    });
};
var $d800ed81bd670610$export$2e2bcd8739ae039 = $d800ed81bd670610$var$listenFormShadowBlurFieldChange;



const $87798b046c4ab648$var$listenFormShadowColorFieldChange = ()=>{
    wp.customize("udb_login[form_shadow_color]", function(setting) {
        setting.bind(function(val) {
            const shadowBlur = wp.customize("udb_login[form_shadow_blur]").get();
            let content = (0, $e6d70ed298135569$export$2e2bcd8739ae039)(shadowBlur, val);
            content = "#loginform {" + content + "}";
            document.querySelector('[data-listen-value="udb_login[form_shadow]"]').innerHTML = content;
        });
    });
};
var $87798b046c4ab648$export$2e2bcd8739ae039 = $87798b046c4ab648$var$listenFormShadowColorFieldChange;


const $eaeb21b7250057d3$var$listenFormLayoutFieldsChange = ()=>{
    (0, $4f54732ff3b04826$export$2e2bcd8739ae039)();
    (0, $adb9332d1a2f0a7d$export$2e2bcd8739ae039)();
    (0, $d1f094e7e877f0f2$export$2e2bcd8739ae039)();
    (0, $9acbbdb133c86a5a$export$2e2bcd8739ae039)();
    (0, $798a250210e66623$export$2e2bcd8739ae039)();
    (0, $855fcbbd98ade068$export$2e2bcd8739ae039)();
    (0, $04a84d6571bea074$export$2e2bcd8739ae039)();
    (0, $03136e43d792eff5$export$2e2bcd8739ae039)();
    (0, $933c10a2d63d6c1a$export$2e2bcd8739ae039)();
    (0, $3469419d17429865$export$2e2bcd8739ae039)();
    (0, $ec63a27f6e3e788d$export$2e2bcd8739ae039)();
    (0, $d800ed81bd670610$export$2e2bcd8739ae039)();
    (0, $87798b046c4ab648$export$2e2bcd8739ae039)();
};
var $eaeb21b7250057d3$export$2e2bcd8739ae039 = $eaeb21b7250057d3$var$listenFormLayoutFieldsChange;


// Import fields change listeners.
const $be0232218c6cd4ce$var$listenFieldsHeightFieldChange = ()=>{
    wp.customize("udb_login[fields_height]", function(setting) {
        setting.bind(function(val) {
            let valueUnit = val.replace(/\d+/g, "");
            valueUnit = valueUnit ? valueUnit : "px";
            let valueNumber = parseInt(val.replace(valueUnit, "").trim(), 10);
            const hidePwTop = valueNumber / 2 - 20;
            const content = val ? ".login input[type=text], .login input[type=password] {height: " + val + ";} .login .button.wp-hide-pw {margin-top: " + hidePwTop.toString() + valueUnit + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_height]"]').innerHTML = content;
        });
    });
};
var $be0232218c6cd4ce$export$2e2bcd8739ae039 = $be0232218c6cd4ce$var$listenFieldsHeightFieldChange;


const $99a199f3ce88c7ab$var$listenFieldsHorizontalPaddingFieldChange = ()=>{
    wp.customize("udb_login[fields_horizontal_padding]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text], .login input[type=password] {padding: 0 " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_horizontal_padding]"]').innerHTML = content;
        });
    });
};
var $99a199f3ce88c7ab$export$2e2bcd8739ae039 = $99a199f3ce88c7ab$var$listenFieldsHorizontalPaddingFieldChange;


const $a22becfdb344da8b$var$listenFieldsBorderWidthFieldChange = ()=>{
    wp.customize("udb_login[fields_border_width]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text], .login input[type=password] {border-width: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_border_width]"]').innerHTML = content;
        });
    });
};
var $a22becfdb344da8b$export$2e2bcd8739ae039 = $a22becfdb344da8b$var$listenFieldsBorderWidthFieldChange;


const $4df2d50b57bcaa31$var$listenFieldsBorderRadiusFieldChange = ()=>{
    wp.customize("udb_login[fields_border_radius]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text], .login input[type=password] {border-radius: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_border_radius]"]').innerHTML = content;
        });
    });
};
var $4df2d50b57bcaa31$export$2e2bcd8739ae039 = $4df2d50b57bcaa31$var$listenFieldsBorderRadiusFieldChange;



const $7dc7f61ab5a83583$var$listenFieldsFontSizeFieldChange = ()=>{
    wp.customize("udb_login[fields_font_size]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "24px";
            (0, $6bf77abec7ca7d4b$export$2e2bcd8739ae039)({
                styleEl: '[data-listen-value="udb_login[fields_font_size]"]',
                cssSelector: ".login input[type=text], .login input[type=password]",
                cssRules: "font-size: " + val + ";"
            });
        });
    });
};
var $7dc7f61ab5a83583$export$2e2bcd8739ae039 = $7dc7f61ab5a83583$var$listenFieldsFontSizeFieldChange;


const $4c882a52c41a3d3f$var$listenFieldsTextColorFieldChange = ()=>{
    wp.customize("udb_login[fields_text_color]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text], .login input[type=password] {color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_text_color]"]').innerHTML = content;
        });
    });
};
var $4c882a52c41a3d3f$export$2e2bcd8739ae039 = $4c882a52c41a3d3f$var$listenFieldsTextColorFieldChange;


const $2b05c8395ab3e444$var$listenFieldsTextColorFocusFieldChange = ()=>{
    wp.customize("udb_login[fields_text_color_focus]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text]:focus, .login input[type=password]:focus {color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_text_color_focus]"]').innerHTML = content;
        });
    });
};
var $2b05c8395ab3e444$export$2e2bcd8739ae039 = $2b05c8395ab3e444$var$listenFieldsTextColorFocusFieldChange;


const $fc90733b1267ba28$var$listenFieldsBgColorFieldChange = ()=>{
    wp.customize("udb_login[fields_bg_color]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text], .login input[type=password] {background-color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_bg_color]"]').innerHTML = content;
        });
    });
};
var $fc90733b1267ba28$export$2e2bcd8739ae039 = $fc90733b1267ba28$var$listenFieldsBgColorFieldChange;


const $f1d34cab49eae26b$var$listenFieldsBgColorFocusFieldChange = ()=>{
    wp.customize("udb_login[fields_bg_color_focus]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text]:focus, .login input[type=password]:focus {background-color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_bg_color_focus]"]').innerHTML = content;
        });
    });
};
var $f1d34cab49eae26b$export$2e2bcd8739ae039 = $f1d34cab49eae26b$var$listenFieldsBgColorFocusFieldChange;


const $01446c7ae5b72798$var$listenFieldsBorderColorFieldChange = ()=>{
    wp.customize("udb_login[fields_border_color]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text], .login input[type=password] {border-color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_border_color]"]').innerHTML = content;
        });
    });
};
var $01446c7ae5b72798$export$2e2bcd8739ae039 = $01446c7ae5b72798$var$listenFieldsBorderColorFieldChange;


const $86f2db7a7bf0ea18$var$listenFieldsBorderColorFocusFieldChange = ()=>{
    wp.customize("udb_login[fields_border_color_focus]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".login input[type=text]:focus, .login input[type=password]:focus {border-color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[fields_border_color_focus]"]').innerHTML = content;
        });
    });
};
var $86f2db7a7bf0ea18$export$2e2bcd8739ae039 = $86f2db7a7bf0ea18$var$listenFieldsBorderColorFocusFieldChange;


const $ea993373e44a3a27$var$listenFormFieldsChange = ()=>{
    (0, $be0232218c6cd4ce$export$2e2bcd8739ae039)();
    (0, $99a199f3ce88c7ab$export$2e2bcd8739ae039)();
    (0, $a22becfdb344da8b$export$2e2bcd8739ae039)();
    (0, $4df2d50b57bcaa31$export$2e2bcd8739ae039)();
    (0, $7dc7f61ab5a83583$export$2e2bcd8739ae039)();
    (0, $4c882a52c41a3d3f$export$2e2bcd8739ae039)();
    (0, $2b05c8395ab3e444$export$2e2bcd8739ae039)();
    (0, $fc90733b1267ba28$export$2e2bcd8739ae039)();
    (0, $f1d34cab49eae26b$export$2e2bcd8739ae039)();
    (0, $01446c7ae5b72798$export$2e2bcd8739ae039)();
    (0, $86f2db7a7bf0ea18$export$2e2bcd8739ae039)();
};
var $ea993373e44a3a27$export$2e2bcd8739ae039 = $ea993373e44a3a27$var$listenFormFieldsChange;


const $ac42fe8fe4c94b67$var$listenLabelColorFieldChange = ()=>{
    wp.customize("udb_login[labels_color]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "#444444";
            document.querySelector('[data-listen-value="udb_login[labels_color]"]').innerHTML = "#loginform label {color: " + val + ";}";
        });
    });
};
var $ac42fe8fe4c94b67$export$2e2bcd8739ae039 = $ac42fe8fe4c94b67$var$listenLabelColorFieldChange;


const $e4e8f9783922afbd$var$listenLabelFontSizeFieldChange = ()=>{
    wp.customize("udb_login[labels_font_size]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "14px";
            document.querySelector('[data-listen-value="udb_login[labels_font_size]"]').innerHTML = "#loginform label {font-size: " + val + ";}";
        });
    });
};
var $e4e8f9783922afbd$export$2e2bcd8739ae039 = $e4e8f9783922afbd$var$listenLabelFontSizeFieldChange;


const $6148c6c94ca43d34$var$listenLabelFieldsChange = ()=>{
    (0, $ac42fe8fe4c94b67$export$2e2bcd8739ae039)();
    (0, $e4e8f9783922afbd$export$2e2bcd8739ae039)();
};
var $6148c6c94ca43d34$export$2e2bcd8739ae039 = $6148c6c94ca43d34$var$listenLabelFieldsChange;


const $a699d66f1183e9f1$var$listenButtonBgColorFieldChange = ()=>{
    wp.customize("udb_login[button_bg_color]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".wp-core-ui .button.button-large {background-color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[button_bg_color]"]').innerHTML = content;
        });
    });
};
var $a699d66f1183e9f1$export$2e2bcd8739ae039 = $a699d66f1183e9f1$var$listenButtonBgColorFieldChange;


const $71a8c3302bad6522$var$listenButtonBgColorHoverFieldChange = ()=>{
    wp.customize("udb_login[button_bg_color_hover]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".wp-core-ui .button.button-large:hover, .wp-core-ui .button.button-large:focus {background-color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[button_bg_color_hover]"]').innerHTML = content;
        });
    });
};
var $71a8c3302bad6522$export$2e2bcd8739ae039 = $71a8c3302bad6522$var$listenButtonBgColorHoverFieldChange;


const $d5f53cfc9b20cb6f$var$listenButtonBorderRadiusFieldChange = ()=>{
    wp.customize("udb_login[button_border_radius]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".wp-core-ui .button.button-large {border-radius: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[button_border_radius]"]').innerHTML = content;
        });
    });
};
var $d5f53cfc9b20cb6f$export$2e2bcd8739ae039 = $d5f53cfc9b20cb6f$var$listenButtonBorderRadiusFieldChange;


const $12d0be34962ca0c6$var$listenButtonHeightFieldChange = ()=>{
    wp.customize("udb_login[button_height]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".wp-core-ui .button.button-large {height: " + val + "; line-height: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[button_height]"]').innerHTML = content;
        });
    });
};
var $12d0be34962ca0c6$export$2e2bcd8739ae039 = $12d0be34962ca0c6$var$listenButtonHeightFieldChange;


const $6a153bd3455606e2$var$listenButtonHorizontalPaddingFieldChange = ()=>{
    wp.customize("udb_login[button_horizontal_padding]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".wp-core-ui .button.button-large {padding: 0 " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[button_horizontal_padding]"]').innerHTML = content;
        });
    });
};
var $6a153bd3455606e2$export$2e2bcd8739ae039 = $6a153bd3455606e2$var$listenButtonHorizontalPaddingFieldChange;


const $be207234439709b6$var$listenButtonTextColorFieldChange = ()=>{
    wp.customize("udb_login[button_text_color]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "#ffffff";
            document.querySelector('[data-listen-value="udb_login[button_text_color]"]').innerHTML = ".wp-core-ui .button.button-large {color: " + val + ";}";
        });
    });
};
var $be207234439709b6$export$2e2bcd8739ae039 = $be207234439709b6$var$listenButtonTextColorFieldChange;


const $c6128ae2aa7d663d$var$listenButtonTextColorHoverFieldChange = ()=>{
    wp.customize("udb_login[button_text_color_hover]", function(setting) {
        setting.bind(function(val) {
            var content = val ? ".wp-core-ui .button.button-large:hover, .wp-core-ui .button.button-large:focus {color: " + val + ";}" : "";
            document.querySelector('[data-listen-value="udb_login[button_text_color_hover]"]').innerHTML = content;
        });
    });
};
var $c6128ae2aa7d663d$export$2e2bcd8739ae039 = $c6128ae2aa7d663d$var$listenButtonTextColorHoverFieldChange;


const $59fdeed4d6421efb$var$listenButtonFieldsChange = ()=>{
    (0, $12d0be34962ca0c6$export$2e2bcd8739ae039)();
    (0, $6a153bd3455606e2$export$2e2bcd8739ae039)();
    (0, $be207234439709b6$export$2e2bcd8739ae039)();
    (0, $c6128ae2aa7d663d$export$2e2bcd8739ae039)();
    (0, $a699d66f1183e9f1$export$2e2bcd8739ae039)();
    (0, $71a8c3302bad6522$export$2e2bcd8739ae039)();
    (0, $d5f53cfc9b20cb6f$export$2e2bcd8739ae039)();
};
var $59fdeed4d6421efb$export$2e2bcd8739ae039 = $59fdeed4d6421efb$var$listenButtonFieldsChange;


const $3b5b5b7a562093b2$var$listenFooterLinkColorFieldChange = ()=>{
    wp.customize("udb_login[footer_link_color]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "#555d66";
            document.querySelector('[data-listen-value="udb_login[footer_link_color]"]').innerHTML = ".login #nav a, .login #backtoblog a {color: " + val + ";}";
        });
    });
};
var $3b5b5b7a562093b2$export$2e2bcd8739ae039 = $3b5b5b7a562093b2$var$listenFooterLinkColorFieldChange;


const $6abbca944ebc7965$var$listenFooterLinkColorHoverFieldChange = ()=>{
    wp.customize("udb_login[footer_link_color_hover]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "#00a0d2";
            document.querySelector('[data-listen-value="udb_login[footer_link_color_hover]"]').innerHTML = ".login #nav a:hover, .login #nav a:focus, .login #backtoblog a:hover, .login #backtoblog a:focus {color: " + val + ";}";
        });
    });
};
var $6abbca944ebc7965$export$2e2bcd8739ae039 = $6abbca944ebc7965$var$listenFooterLinkColorHoverFieldChange;


const $c123ceeee0eae167$var$listenBackToSiteToggle = ()=>{
    wp.customize("udb_login[remove_back_to_site_link]", function(setting) {
        setting.bind(function(val) {
            const display = val ? "none" : "block";
            document.querySelector('[data-listen-value="udb_login[remove_back_to_site_link]"]').innerHTML = ".login #backtoblog {display: " + display + ";}";
        });
    });
};
var $c123ceeee0eae167$export$2e2bcd8739ae039 = $c123ceeee0eae167$var$listenBackToSiteToggle;


const $36654871b43b8194$var$listenLangSwitcherToggle = ()=>{
    wp.customize("udb_login[remove_lang_switcher]", function(setting) {
        setting.bind(function(val) {
            const display = val ? "none" : "block";
            document.querySelector('[data-listen-value="udb_login[remove_lang_switcher]"]').innerHTML = "#login .language-switcher {display: " + display + ";}";
        });
    });
};
var $36654871b43b8194$export$2e2bcd8739ae039 = $36654871b43b8194$var$listenLangSwitcherToggle;


const $60a5a73b4e330a84$var$listenRegisterAndLostPwLinksToggle = ()=>{
    wp.customize("udb_login[remove_register_lost_pw_link]", function(setting) {
        setting.bind(function(val) {
            const display = val ? "none" : "block";
            document.querySelector('[data-listen-value="udb_login[remove_register_lost_pw_link]"]').innerHTML = ".login #nav {display: " + display + ";}";
        });
    });
};
var $60a5a73b4e330a84$export$2e2bcd8739ae039 = $60a5a73b4e330a84$var$listenRegisterAndLostPwLinksToggle;


const $a25760410048c9a5$var$listenFooterFieldsChange = ()=>{
    (0, $3b5b5b7a562093b2$export$2e2bcd8739ae039)();
    (0, $6abbca944ebc7965$export$2e2bcd8739ae039)();
    (0, $60a5a73b4e330a84$export$2e2bcd8739ae039)();
    (0, $c123ceeee0eae167$export$2e2bcd8739ae039)();
    (0, $36654871b43b8194$export$2e2bcd8739ae039)();
};
var $a25760410048c9a5$export$2e2bcd8739ae039 = $a25760410048c9a5$var$listenFooterFieldsChange;


const $38bc6da090442aab$var$listenCustomCssFieldChange = ()=>{
    wp.customize("udb_login[custom_css]", function(setting) {
        setting.bind(function(val) {
            val = val ? val : "";
            document.querySelector('[data-listen-value="udb_login[custom_css]"]').innerHTML = val;
        });
    });
};
var $38bc6da090442aab$export$2e2bcd8739ae039 = $38bc6da090442aab$var$listenCustomCssFieldChange;



const $479e5743454bbf45$var$listenTemplateFieldChange = ()=>{
    wp.customize("udb_login[template]", function(setting) {
        setting.bind(function(val) {
            if (val !== "default") (0, $a27ec4aed69ec0cd$export$2e2bcd8739ae039).show();
            else (0, $a27ec4aed69ec0cd$export$2e2bcd8739ae039).hide();
        });
    });
};
var $479e5743454bbf45$export$2e2bcd8739ae039 = $479e5743454bbf45$var$listenTemplateFieldChange;


const $40961bc756c1c785$var$listenBgColorFieldChange = ()=>{
    wp.customize("udb_login[bg_color]", function(setting) {
        const bgColorStyleTag = document.querySelector('[data-listen-value="udb_login[bg_color]"]');
        setting.bind(function(val) {
            val = val ? val : "#f1f1f1";
            bgColorStyleTag.innerHTML = "body.login {background-color: " + val + ";}";
        });
    });
};
var $40961bc756c1c785$export$2e2bcd8739ae039 = $40961bc756c1c785$var$listenBgColorFieldChange;


/**
 * Scripts within customizer preview window.
 *
 * Used global objects:
 * - jQuery
 * - wp
 * - udbLoginCustomizer
 */ (function($) {
    wp.customize.bind("preview-ready", function() {
        listen();
    });
    const listen = ()=>{
        listenCustomEvents();
        listenFieldsChanges();
    };
    const listenCustomEvents = ()=>{
        (0, $a73a302a0251d813$export$2e2bcd8739ae039)();
        if (!udbLoginCustomizer.isProActive) (0, $e6d08691f65044c6$export$2e2bcd8739ae039)();
    };
    const listenFieldsChanges = ()=>{
        if (!udbLoginCustomizer.isProActive) (0, $479e5743454bbf45$export$2e2bcd8739ae039)();
        (0, $fc3864525fc0e41d$export$2e2bcd8739ae039)();
        (0, $40961bc756c1c785$export$2e2bcd8739ae039)();
        (0, $69d53b767702c009$export$2e2bcd8739ae039)({
            keyPrefix: "",
            cssSelector: "body.login"
        });
        (0, $69d53b767702c009$export$2e2bcd8739ae039)({
            keyPrefix: "form_",
            cssSelector: ".login form, #loginform"
        });
        (0, $eaeb21b7250057d3$export$2e2bcd8739ae039)();
        (0, $ea993373e44a3a27$export$2e2bcd8739ae039)();
        (0, $6148c6c94ca43d34$export$2e2bcd8739ae039)();
        (0, $59fdeed4d6421efb$export$2e2bcd8739ae039)();
        (0, $a25760410048c9a5$export$2e2bcd8739ae039)();
        (0, $38bc6da090442aab$export$2e2bcd8739ae039)();
    };
})((0, (/*@__PURE__*/$parcel$interopDefault($9ecc61fdda8d7e00$exports))));

})();
//# sourceMappingURL=preview.js.map
